export default __webpack_public_path__ + "static/media/tsnap.b89fae7d.png";